var path = '/common/formly/wrappers/tpl/validation.html';
var html = "<formly-transclude></formly-transclude> <span id=\"{{::id + '-refresh'}}\" class=\"glyphicon glyphicon-refresh loader\" ng-show=to.loading></span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/wrappers/tpl/validation.html
// module id = 459
// module chunks = 0 1 3